import { RouteConfig } from 'vue-router';

const SelfEmployeeView = () => import('@/views/self-employee.vue');
const SelfEmployeeViewIndex = () => import('@/views/self-employee/index.vue');

const TaxPayersView = () => import('@/views/self-employee/tax-payers.vue');
const TaxPayersViewIndex = () =>
  import('@/views/self-employee/tax-payers/index.vue');

const PartnersView = () => import('@/views/self-employee/partners.vue');
const PartnersViewIndex = () =>
  import('@/views/self-employee/partners/index.vue');

const InfoView = () => import('@/views/info/stats/index.vue');
const ReportsView = () => import('@/views/self-employee/reports/index.vue');
const ReportReciepts = () =>
  import('@/views/self-employee/reports/report-tax-receipts.vue');
const ReportTaxpayers = () =>
  import('@/views/self-employee/reports/report-taxpayers.vue');

export default {
  path: '/self-employee',
  component: SelfEmployeeView,
  meta: {
    name: 'page.selfEmployee',
  },
  children: [
    {
      path: '',
      name: 'self-employee-index',
      redirect: { name: 'self-employee-taxpayers-index' },
      component: SelfEmployeeViewIndex,
    },
    {
      path: 'taxpayers',
      component: TaxPayersView,
      meta: {
        name: 'section.taxPayers',
      },
      children: [
        {
          path: '',
          name: 'self-employee-taxpayers-index',
          component: TaxPayersViewIndex,
        },
      ],
    },
    {
      path: 'partners',
      component: PartnersView,
      meta: {
        name: 'section.partners',
      },
      children: [
        {
          path: '',
          name: 'self-employee-partners-index',
          component: PartnersViewIndex,
        },
      ],
    },
    {
      path: 'info',
      component: InfoView,
      name: 'self-employee-info-index',
      meta: {
        name: 'section.info',
      },
    },
    {
      path: 'reports',
      component: ReportsView,
      name: 'self-employee-reports',
      meta: {
        name: 'section.reports',
      },
    },
    {
      path: 'report-taxpayers',
      component: ReportTaxpayers,
      name: 'self-employee-report-taxpayers',
      meta: {
        name: 'section.reports',
      },
    },
    {
      path: 'report-receipts',
      component: ReportReciepts,
      name: 'self-employee-report-tax-receipts',
      meta: {
        name: 'section.reports',
      },
    },
  ],
} as RouteConfig;
